import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "availability-export-item",
  templateUrl: "availability-export-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule, RouterLink],
})
export class AvailabilityExportItem {
  protected subscription = input.required<{ subscriptionId: string; product: { type: string; tag: string } }>();
}
